import React from 'react'

const RapportClotureVilleForm = () => {
  return (
    <div>RapportClotureVilleForm</div>
  )
}

export default RapportClotureVilleForm